module.exports = __webpack_public_path__ + "img/exit.61539bc7.gif";